import { render } from "./Inscription.vue?vue&type=template&id=5c5e97bf&ts=true"
import script from "./Inscription.vue?vue&type=script&lang=ts"
export * from "./Inscription.vue?vue&type=script&lang=ts"

import "./Inscription.vue?vue&type=style&index=0&id=5c5e97bf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__